var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[(!_vm.$store.state.isAdminLoggedIn && !_vm.$store.state.isTrainerLoggedIn)?_c('page-header'):_c('admin-header'),_vm._v(" "),_c('logout-timer'),_vm._v(" "),_c('main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }